export const MANAGEMENT_COMPANY_EMPLOYEE = 'management_company_employee';
export const CLIENT = 'client';
export const OWNER = 'owner';
export const GUEST = 'guest';
